<template>
<h1 class="text-center my-4 text-4xl">User Order</h1>
  
<div class="w-full max-w-6xl mx-auto border-2 border-black border-solid text-center">
    <div class="py-2 border-b border-black">
        <div class="grid grid-cols-5">
            <div class="text-2xl">Complete</div> 
        </div>
    </div>

    <div class="grid grid-cols-5 bg-gray-50 border-t-2 border-black border-b-2 font-medium py-2">
      <div class="font-semibold">Order No.</div>
      <div class="font-semibold">Status</div>
      <div class="font-semibold">Purchase Date</div>
      <div class="font-semibold">Order Item</div>
      <div class="font-semibold">Quantity</div>
    </div>
    <div>
        
            <div class="grid grid-cols-5 py-3 border-b border-gray-300">
                <div class="flex flex-col justify-center">
                    <div>001</div>
                </div>
                    
                <div class="flex flex-col justify-center">
                    <div>Success</div>
                </div>

                <div class="flex flex-col justify-center">
                    <div>{{ formattedDate(-7) }}</div> 
                </div>
                    
                <div class="flex flex-col justify-center">
                    <div>Buffalo - Striploin</div>
                    <div>Bacardi Breezer - Tropical</div>
                </div>

                <div class="flex flex-col justify-center">
                    <div>1</div>
                    <div>2</div>
                </div>

            </div>
        
    </div>



</div>

<br class="mt-4">

<div class="w-full max-w-6xl mx-auto border-2 border-black border-solid text-center">
    <div class="py-2 border-b border-black">
        <div class="grid grid-cols-5">
            <div class="text-2xl">Process</div> 
        </div>
    </div>

    <div class="grid grid-cols-5 bg-gray-50 border-t-2 border-black border-b-2 font-medium py-2">
      <div class="font-semibold">Order No.</div>
      <div class="font-semibold">Status</div>
      <div class="font-semibold">Purchase Date</div>
      <div class="font-semibold">Order Item</div>
      <div class="font-semibold">Quantity</div>
    </div>
    <div class="grid grid-cols-5 py-6 border-b border-gray-300">
        <div class="col-span-5 flex items-center justify-center text-xl text-black-500 ">No process item </div>
    </div>

</div>
</template>

<script setup>
import { ref, onMounted } from 'vue'; 

const purchaseDate = ref(new Date());

const formattedDate = (daysOffset = 0) => {
    try {
        const targetDate = new Date(purchaseDate.value);

        targetDate.setDate(targetDate.getDate() + daysOffset);

        const yyyy = targetDate.getFullYear();
        const mm = String(targetDate.getMonth() + 1).padStart(2, '0');
        const dd = String(targetDate.getDate()).padStart(2, '0');

        return `${yyyy}/${mm}/${dd}`;
    } catch (error) {
        console.error("日期格式化出錯:", error);
        return '';
    }
};

const getDate = () => {
    console.log('目前的購買日期是：', formattedDate(-7));
};

onMounted(() => {
    getDate();
});

</script>